import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-work-order-report-issue',
    templateUrl: './breadcrumb.work.order.report.issue.component.html'
})

export class BreadcrumbWorkOrderReportIssueComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() workOrderId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
